'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$LocalPjeOfficeCertChainResponse(origin, hash, chain) {
  this.X2 = null;
  this.X1 = null;
  this.X0 = null;
  this.X2 = origin;
  this.X1 = hash;
  this.X0 = chain;
}
export { $c_Lpresto_AgentView$LocalPjeOfficeCertChainResponse as $c_Lpresto_AgentView$LocalPjeOfficeCertChainResponse };
$p = $c_Lpresto_AgentView$LocalPjeOfficeCertChainResponse.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$LocalPjeOfficeCertChainResponse;
/** @constructor */
function $h_Lpresto_AgentView$LocalPjeOfficeCertChainResponse() {
}
export { $h_Lpresto_AgentView$LocalPjeOfficeCertChainResponse as $h_Lpresto_AgentView$LocalPjeOfficeCertChainResponse };
$h_Lpresto_AgentView$LocalPjeOfficeCertChainResponse.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_AgentView$LocalPjeOfficeCertChainResponse) && (((this.X2 === x$0.X2) && (this.X1 === x$0.X1)) && (this.X0 === x$0.X0))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "LocalPjeOfficeCertChainResponse";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.X2;
      break;
    }
    case 1: {
      return this.X1;
      break;
    }
    case 2: {
      return this.X0;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_AgentView$LocalPjeOfficeCertChainResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hB)));
}
export { $isArrayOf_Lpresto_AgentView$LocalPjeOfficeCertChainResponse as $isArrayOf_Lpresto_AgentView$LocalPjeOfficeCertChainResponse };
var $d_Lpresto_AgentView$LocalPjeOfficeCertChainResponse = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$LocalPjeOfficeCertChainResponse, "presto.AgentView$LocalPjeOfficeCertChainResponse", ({
  hB: 1,
  bv: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_AgentView$LocalPjeOfficeCertChainResponse as $d_Lpresto_AgentView$LocalPjeOfficeCertChainResponse };
//# sourceMappingURL=presto.-Agent-View$-Local-Pje-Office-Cert-Chain-Response.js.map
